import { Tag } from "antd";
import styled from "styled-components";
import { TListHook } from "../../@types/common";
import { Button } from "../../components/common/Button";
import { Divider } from "../../components/elements/Elements";
import { FundingCard } from "../../components/pages/loans/FundingCard";
import { FUND_LOAN } from "../../constants/constants";
import { searchFilterField } from "../../constants/options";
import { productsData } from "../../dump";
import {
  currencyFormat,
  formatDate,
  getLoanGrade,
  stringify,
} from "../../utils/helpers";
import { openBottomSheet, openModalForm } from "../../utils/modalUtils";

export const useProductsList = (): TListHook => {
  const filters = [searchFilterField];

  return {
    listType: "grid",
    ListItem: ProductItem,
    // title: "Institution Title",
    // api: API_LOAN_PRODUCTS,
    defaultValues: productsData,
    filters,
    showBack: true,
  };
};

const InvestFooter = ({ state }: { state?: any }) => {
  const {
    total_units,
    units_available,
    unit_price,
    funding_percentage,
    current_funding,
  } = state || {};

  const progress = 100 - (units_available / total_units) * 100;
  const funded = unit_price * (total_units - units_available);
  const balance = unit_price * total_units - funded;

  return (
    <>
      <FundingCard
        progress={funding_percentage}
        balance={balance}
        funded={current_funding}
      />
      <Button
        onClick={() => {
          openModalForm({
            source: FUND_LOAN,
            state,
          });
        }}
        className="x100"
      >
        Invest Now
      </Button>
    </>
  );
};

export const ProductItem = ({ data }: { data: any }) => {
  const {
    invest,
    purpose,
    net_return: netReturn,
    expected_payout,
    risk_level: riskLevel,
    duration_display,
    unit_price,
    backed_by,
    guaranteed_principal,
    total_units,
    units_available,
    payout_date,

    name,
    min_investment,
    description,
    type,
    investment_term_months,
    image,
    expected_return_min,
    expected_return_max,
    status,
    investors_count,
    funding_deadline,
    created_at,
  } = data || {};

  const { label, color } = getLoanGrade(riskLevel);

  const risk_level = <div style={{ color }}>{label}</div>;
  const duration = `${investment_term_months} months`;
  const net_return = (
    <Tag className="font11" style={{ margin: 0 }} color="green">
      {netReturn?.replace(".00", "")}
    </Tag>
  );

  const fields = {
    duration,
    expected_return: `${expected_return_min}% - ${expected_return_max}%`,
    risk_level: riskLevel,
  };

  const openDetails = () => {
    openBottomSheet({
      component: "details",
      title: "Investment Details",
      data: {
        name,
        description,
        min_investment: currencyFormat(min_investment),
        type,
        investment_term_months,
        risk_level: riskLevel,
        expected_return_min: `${expected_return_min}%`,
        expected_return_max: `${expected_return_max}%`,
        status,
        investors_count,
        funding_deadline: formatDate(funding_deadline),
        created_at: formatDate(created_at),

        // invest: currencyFormat(invest),
        // unit_price: currencyFormat(unit_price),
        // net_return,
        // expected_payout: currencyFormat(expected_payout),
        // risk_level: <RiskLevelTag value={riskLevel} />,
        // duration,
        // units_available,
        // total_units,
        // payout_date: formatDate(payout_date),
        // guaranteed_principal,
        // backed_by,
      },
      state: { ...data },
      footer: InvestFooter,
    });
  };

  return (
    <Wrapper className="flexColumn gap10 whiteBg p15 r10 capitalize">
      {/* <div className="flexSpaceCenter">
        {net_return}
      </div> */}

      {/* IMAGE */}
      <img
        className="r10"
        src={image}
        width={"100%"}
        height={120}
        style={{ objectFit: "cover" }}
      />

      {/* HEADER */}
      <div>
        <div className="semiBold textDark">
          {currencyFormat(min_investment)}
        </div>
        <div className="font12 textDark ellipsis">{stringify(name)}</div>
        <div className="font11 grey ellipsis">{stringify(type)}</div>
      </div>

      {/* DESC */}
      <Divider />
      <div className="font11 ellipsis2">{description}</div>

      {/* MID */}
      <Divider />
      <div
        className="flexColumn gap5"
        style={{
          lineHeight: 1.2,
        }}
      >
        {Object.entries(fields).map(([key, value], i) => {
          return (
            <div key={i} className="flexSpaceCenter font11 grey gap10">
              <div>{stringify(key)}</div>
              <div className="textDark textEnd">{value}</div>
            </div>
          );
        })}
      </div>
      <Divider />

      {/* BOTTOM */}
      <Button className="font12 r20" onClick={openDetails}>
        Invest Now
      </Button>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  // @media (max-width: 960px) {
  //   min-width: 150px;
  // }
`;
